import React, { useState, useContext, Suspense, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import { toast } from 'react-toastify';
import style from './Header.module.css';
import logo from '../../../assets/SchoolLink-logo-web.png';
import AuthContext from '../../../store/auth-context';
import { getOrganisation } from '../../../services/notification.services';
import { parseJwtToken } from '../../../utils/jwt.utils';
import { useLogout } from '../../../hooks/useLogout';
import '../../Style/customDropdown.css';
import { SUPER_ADMIN_ID } from '../../../constants';

const SchoolAuthenticationCodeGenerator = React.lazy(
  () => import('../../SchoolAuthenticationCodeGenerator/SchoolAuthenticationCodeGenerator')
);

interface HeaderProps {
  onNavigate?: (path: string) => void;
}

const Header: React.FC<HeaderProps> = () => {
  const authCtx = useContext(AuthContext);
  const navigate = useNavigate();
  const { handleLogout } = useLogout();
  
  const [ePublisherMenu, setEPublisherMenu] = useState(false);
  const [schoolLinkMenu, setSchoolLinkMenu] = useState(false);
  const [isAuthenticationCodeModalOpen, setIsAuthenticationCodeModalOpen] = useState(false);
  const [isImpersonateLoading, setIsImpersonateLoading] = useState(false);

  const authenticationCodeHandler = () => {
    setIsAuthenticationCodeModalOpen(prevState => !prevState);
  };

  const logoutImpersonate = async () => {
    setIsImpersonateLoading(true);
    
    try {
      // Retrieve original super admin credentials from localStorage
      const superAdminToken = localStorage.getItem('super-admin-token');
      const superAdminName = localStorage.getItem('super-admin-name');
      const storedUsertype = localStorage.getItem('super-admin-usertype');
      const superAdminUsertype = (storedUsertype === 'INTERNALADMIN' ? 'INTERNALADMIN' : 'OWNER') as 'OWNER' | 'INTERNALADMIN';
      
      if (!superAdminToken) {
        toast.error('Could not retrieve super admin credentials.');
        setIsImpersonateLoading(false);
        return;
      }

      // Parse the super admin token to get user details
      const tokenUserData = parseJwtToken(superAdminToken);
      const orgId = tokenUserData.user.org;
      const uid = tokenUserData.user.id;
      
      // Fetch organization details using super admin token
      //const res = await getOrganisation(orgId, superAdminToken);
      
      // Handle both array response and single object response
      //const org = Array.isArray(res) ? res[0] : res;
      
      //if (!org || org.status === 400) {
      //  throw new Error('Could not get organisation this user belongs to');
      //}

      // Restore super admin session data
      const userData = {
        uuid: tokenUserData.user.uuid,
        user_id: uid,
        name: superAdminName,
        uid: uid,
        usertype: superAdminUsertype,
        orgName: undefined,
        orgLogoUrl: undefined,
        token: superAdminToken,
        orgId: undefined,
        orgWisitiaID:undefined,
        epubOrgId: undefined,
        thumbImage: authCtx.userData?.thumbImage,
        CHANNEL_PUSH_NOTIFICATION: undefined,
        EDITOR_ATTACHMENT: undefined,
        EDITOR_EXTERNAL_LINK: undefined,
        EDITOR_LINK: undefined,
        EDITOR_TEXT: undefined,
        EDIT_EMOJI: undefined,
        EDIT_EPUB: undefined
      };
      
      // Clear impersonation data from localStorage
      localStorage.removeItem('super-admin');
      localStorage.removeItem('super-admin-token');
      localStorage.removeItem('super-admin-name');
      localStorage.removeItem('super-admin-usertype');
      
      // Restore super admin session
      authCtx.login(userData);
      navigate('/Organisation#organisations');
    } catch (err) {
      toast.error('Could not retrieve organisation: ' + (err instanceof Error ? err.message : 'Unknown error'));
    } finally {
      setIsImpersonateLoading(false);
    }
  };

  useEffect(() => {
    if (authCtx.userData && authCtx.userData.thumbImage !== null) {
      authCtx.setUProfileImage(authCtx.userData.thumbImage);
    }
  }, [authCtx.userData, authCtx, isAuthenticationCodeModalOpen]);

  return (
    <>
      {isAuthenticationCodeModalOpen && (
        <Suspense fallback={<div>Loading...</div>}>
          <SchoolAuthenticationCodeGenerator
            show={isAuthenticationCodeModalOpen}
            onclick={authenticationCodeHandler}
          />
        </Suspense>
      )}
      <div className={authCtx.userData?.superAdminName ? 'superAdminSelectOrg' : ''}>
        <header className={'d-flex flex-column flex-md-row align-items-center box-shadow ' + style.Header}>
          <div className={authCtx.userData?.superAdminName ? 'orgUserArea' : ''}>
            {authCtx.userData?.superAdminName && (
              <div>
              <span>
                ( Impersonating as {authCtx.userData.name} ) {authCtx.userData.orgName} 
              </span>

              <button
                    style={{ marginLeft: '10px', border: 'none', borderRadius: '5px', padding: '2px 10px',background: '#ffffff', color: '#131313ff', cursor: 'pointer'  }}
                    onClick={() => logoutImpersonate()}
                    disabled={isImpersonateLoading}
                    type="button"
                  >
                    {isImpersonateLoading ? 'Loading...' : 'Exit Impersonation'}
                  </button>
              </div>
            )}
          </div>
          <div className={'row ' + style.HeaderboxShadow}>
            <div className={'col-md-6 ' + style.logo}>
              <a
                href={
                  authCtx.userData && authCtx.userData.user_id !== SUPER_ADMIN_ID
                    ? '/notifications'
                    : '/Organisation#internalUser'
                }
              >
                <img src={logo} alt="SchoolLink" className={style.logoImg} />
              </a>
            </div>

            <Dropdown className={'col-md-6 ' + style.rightMenu}>
              <div className={style.menuHead}>
                
                <Dropdown.Toggle
                  variant="userBtn"
                  id="dropdown-basic"
                  className={authCtx.userData?.superAdminName ? 'usperAdmin' : ''}
                  disabled={isImpersonateLoading}
                  style={{display:'flex', flexDirection:'row', textAlign:'left'}}
                >
                  <div>{authCtx.userData?.name}
                  {authCtx.userData?.superAdminName && (
                    <span className="userAlign">
                       <br />
                      <span className="otherUser">( Impersonated by {authCtx.userData?.superAdminName} )</span>&nbsp;
                    </span>
                  )}
                  <span className="">
                                      &nbsp;
                    <span className="selectUser">{authCtx.userData?.orgName} ({authCtx.userData?.usertype === 'OWNER' ? 'SUPER ADMIN' : authCtx.userData?.usertype})</span>
                  </span>
                  </div>
                  <img className="userImg" alt="user" src={authCtx.userData?.thumbImage || authCtx.uProfileImage || ''} />
                  
                </Dropdown.Toggle>
                <Dropdown.Menu className="dropBox userArea">
                  <div
                    className="dropdown-item child-menu"
                    onMouseEnter={() => setEPublisherMenu(true)}
                    onMouseLeave={() => setEPublisherMenu(false)}
                    title="SchoolLink Config"
                  >
                    <span>
                      <i className="fa fa-users"></i>
                    </span>{' '}
                    SchoolLink config{' '}
                    <span className="menuArrow">
                      <i className="icon icon-arrow-right3"></i>
                    </span>
                    {ePublisherMenu && (
                      <div className="subMenu">
                        <div className="menuBg">
                          <Dropdown.Item title="My account" as={Link} to="/Organisation#myAccount">
                            <span>
                              <i className="fa fa-user"></i>
                            </span>{' '}
                            My account
                          </Dropdown.Item>
                          <Dropdown.Item
                            title="Account Settings & Users"
                            as={Link}
                            to="/Organisation#users"
                          >
                            <span>
                              <i className="fa fa-users"></i>
                            </span>{' '}
                            Account Settings & Users
                          </Dropdown.Item>
                          {/* <Dropdown.Item
                            title="Modify School Contact Details"
                            as={Link}
                            to="/ModifyDetails"
                          >
                            <span>
                              <i className="icon icon-phone-plus"></i>
                            </span>{' '}
                            Modify School Contact Details
                          </Dropdown.Item> */}
                          <Dropdown.Item
                            title="App verification code"
                            as={Link}
                            to="/Organisation#schoolauthenticationcode"
                          >
                            <span>
                              <i className="icon icon-key2"></i>
                            </span>{' '}
                            App verification code
                          </Dropdown.Item>
                          {(authCtx.userData?.usertype === 'OWNER' || authCtx.userData?.usertype === 'INTERNALADMIN') && (
                            <>
                              <Dropdown.Item
                                title="Feature configuration"
                                as={Link}
                                to="/Organisation#plans"
                              >
                                <span>
                                  <i className="icon icon-cog2"></i>
                                </span>{' '}
                                Feature configuration
                              </Dropdown.Item>
                              <Dropdown.Item title="Billing" as={Link} to="/Organisation#plans">
                                <span>
                                  <i className="icon icon-credit-card2"></i>
                                </span>{' '}
                                Billing
                              </Dropdown.Item>
                              <Dropdown.Item title="App Users" as={Link} to="/app-users/all">
                                <span>
                                  <i className="fa fa-mobile"></i>
                                </span>{' '}
                                App Users
                              </Dropdown.Item>
                            </>
                          )}

                        </div>
                      </div>
                    )}
                  </div>
                  {authCtx.userData?.usertype === 'OWNER000' && (
                    
                    <div
                      className="dropdown-item child-menu"
                      onMouseEnter={() => setSchoolLinkMenu(true)}
                      onMouseLeave={() => setSchoolLinkMenu(false)}
                      title="ePublisher config"
                    >
                      <span>
                        <i className="fa fa-user"></i>
                      </span>{' '}
                      ePublisher config{' '}
                      <span className="menuArrow">
                        <i className="icon icon-arrow-right3"></i>
                      </span>
                      {schoolLinkMenu && (
                        <div className="subMenu">
                          <div className="menuBg">
                            <Dropdown.Item href="#" title="Manage user accounts">
                              <span>
                                <i className="fa fa-users"></i>
                              </span>{' '}
                              Manage user accounts
                            </Dropdown.Item>
                            <Dropdown.Item href="#" title="Billing">
                              <span>
                                <i className="icon icon-credit-card2"></i>
                              </span>{' '}
                              Billing
                            </Dropdown.Item>
                            <Dropdown.Item href="#" title="All Users">
                              <span>
                                <i className="icon icon-key2"></i>
                              </span>{' '}
                              All Users
                            </Dropdown.Item>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <Dropdown.Item title="Sign Out" onClick={handleLogout}>
                    <span>
                      <i className="fa fa-power-off"></i>
                    </span>{' '}
                    Sign Out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </div>
            </Dropdown>
          </div>
        </header>
      </div>
    </>
  );
};

export default Header;
